import React, { useState } from 'react'
import Loader from '../../../composed/Loader/Loader'
import fallBackImage from '../../../global/assets/png/clock-blue.png'
import { CELEBRITY_CHEF_SUB_TEXT } from "../../../global/constants";
import { TEST_FOOD_1_JPG, TEST_FOOD_2_JPG, TEST_FOOD_3_JPG } from "../../../global/assets/Icons";
import { MealOfferingCalculation } from './../../../global/calculations';
import { Chip } from '@mui/material';

const CelebrityChefMobile = (props) => {

    const { celebrityChefList, handleClickRedirect, customerInfoData } = props
    const [imageLoaded, setImageLoaded] = useState([])
    const [imageError, setImageError] = useState([])
    // console.log('----celebrityChefList Mobile', celebrityChefList)
    const { loading, data, success, errorMessage } = customerInfoData
    const custInfoData = data?.data || [];
    const custMealPlan = custInfoData?.meal_Package?.meal_plan;

    const onImageLoad = (index) => {
        setImageLoaded((prev) => {
            prev[index] = true;
            return [...prev];
        })

    }

    const onImageError = (index) => {
        setImageError((prev) => {
            prev[index] = true;
            return [...prev];
        })

        setImageLoaded((prev) => {
            prev[index] = true;
            return [...prev];
        })
    }

    return (<div style={{
        display: 'flex',
        flexDirection: 'column',
        width: 'auto',
        // width: '700px',
        height: 'auto',
        margin: '10px',
        // marginBottom: '25px', 
        // marginTop: '10px', 
        position: 'relative',
        border: '2px solid #181436',
        borderRadius: '3px',
        cursor: 'pointer',

    }}>

        {celebrityChefList.map((el, index) => (
            <div style={{ cursor: 'pointer', }} key={el.kitchenName} onClick={(e) => handleClickRedirect(e, el)}>
                <div style={{ display: 'flex', flexDirection: 'row', height: '70px', width: '100%', borderBottom: '1px solid #F1F1F1', cursor: 'pointer', }}>
                    <div style={{ width: "65%" }}>
                        <div style={{ color: '#181436', marginLeft: '15px', fontStyle: 'normal', fontWeight: 600, fontSize: '16px', marginTop: '10px' }}>Celebrity Chef </div>
                        <div style={{ color: '#181436', marginLeft: '15px', fontWeight: 400, fontSize: '12px', marginTop: '1px', marginBottom: '10px' }}>{CELEBRITY_CHEF_SUB_TEXT}</div>
                    </div>
                    <div style={{ width: "30%" }}>
                        <Chip label={`Oct 10th - 16th`}
                            size='small' sx={{
                                width: '100%',
                                height: '25px', borderRadius: '5px',
                                border: '1px solid #FF893A',
                                background: '#FF893A', color: '#FFF3EA', fontWeight: 500,
                                fontSize: '12px', margin: '10px'
                            }} />
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', borderBottom: '1px solid #F1F1F1' }}>
                    <div style={{
                        color: 'black',
                        width: '40%',
                        margin: '5px 2px 2px 15px',
                        // marginLeft: '15px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        fontSize: '12px',
                        // marginTop: '05px',
                        height: '130px',
                        border: '3px solid white',
                        backgroundColor: 'white',
                        borderRadius: '5px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        objectFit: 'cover',
                        overflow: 'hidden'
                    }}>
                        <img
                            width={imageLoaded[index] ? '100%' : 0}
                            src={imageError[index] ? fallBackImage : el.display_image}
                            onLoad={() => onImageLoad(index)}
                            onError={() => onImageError(index)}
                            key={el._id}
                        />
                        {!imageLoaded[index] &&
                            <Loader color='black' width='20px' height='20px' />}

                    </div>
                    <div style={{ width: '60%', display: 'flex', flexDirection: 'column', margin: '5px 2px 2px 5px', }}>
                        <div style={{
                            color: '#181436', fontWeight: 600,
                            fontSize: '14px'
                        }}> Gordon James Ramsay</div>
                        <div style={{
                            display: 'flex',
                            color: '#181436', fontWeight: 400,
                            fontSize: '12px', marginTop: '2px',
                            textAlign: 'left', flexWrap: 'wrap'
                        }}>  Gordon James Ramsay OBE is a British celebrity chef, restaurateur, television presenter, and writer. His restaurant group, Gordon Ramsay Restaurants, was founded in 1997 and has been awarded 17 Michelin stars overall and currently holds seven</div>

                    </div>
                </div>

                <div style={{ color: '#FF893A', marginLeft: '15px', fontStyle: 'normal', fontWeight: 500, fontSize: '14px', marginTop: '5px' }}>Combo Items ( Per person )</div>
                <div style={{ color: 'black', marginLeft: '15px', fontStyle: 'normal', fontWeight: 500, fontSize: '12px', marginTop: '3px' }}>1 Main dish + 1 Side</div>

                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
                    <div style={{ width: '170px', height: 'auto', borderRadius: '5px 5px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 5px 0px 15px' }}>
                        <div style={{
                            // height: '160px',
                            borderRadius: '5px 5px 0px 0px',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            objectFit: 'cover',
                            // border: '1px solid red'
                        }}>   <img
                                width={imageLoaded[index] ? '100%' : 0}
                                src={imageError[index] ? fallBackImage : TEST_FOOD_3_JPG}
                                onLoad={() => onImageLoad(index)}
                                onError={() => onImageError(index)}
                                key={el._id}
                            />
                            {!imageLoaded[index] &&
                                <Loader color='black' width='20px' height='20px' />}
                        </div>
                        <div style={{
                            height: 'auto',
                            // borderRadius: '5px 5px 0px 0px',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            flexWrap: 'wrap',
                            borderTop: '1px solid #DBD6D6',
                            padding: '3px'
                        }}>
                            <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                            <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '12px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>
                        </div>

                    </div>
                    <div style={{ width: '170px', height: 'auto', borderRadius: '5px 5px 0px 0px', border: '1px solid #DBD6D6', margin: '10px 10px 0px 0px' }}>
                        <div style={{
                            // height: '160px',
                            borderRadius: '5px 5px 0px 0px',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            objectFit: 'cover',
                            // border: '1px solid red'
                        }}> <img
                                width={imageLoaded[index] ? '100%' : 0}
                                src={imageError[index] ? fallBackImage : TEST_FOOD_2_JPG}
                                onLoad={() => onImageLoad(index)}
                                onError={() => onImageError(index)}
                                key={el._id}
                            />
                            {!imageLoaded[index] &&
                                <Loader color='black' width='20px' height='20px' />}
                        </div>
                        <div style={{
                            height: 'auto',
                            // borderRadius: '5px 5px 0px 0px',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            // flexWrap: 'wrap',
                            // alignItems: 'center',
                            // justifyContent: 'center',
                            borderTop: '1px solid #DBD6D6',
                            padding: '3px'
                            // backgroundColor: '#F8F8F8'
                        }}>
                            <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', marginTop: '1px', marginLeft: '5px' }}> Home Chedf Name </div>
                            <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '12px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>
                        </div>
                    </div>
                </div>
            </div>
        ))
        }

    </div>)

}

export default CelebrityChefMobile